import { useState } from 'react';
import { Polyline, useMapEvents } from 'react-leaflet';
import clsx from 'clsx';
import { haversineMeters, bearingDeg, formatDistance, formatBearing } from '../../lib/geo';
import type { LatLon } from '../../types/domain';

// Two-click distance + bearing tool (docs/14 §6).
export default function Rangefinder() {
  const [active, setActive] = useState(false);
  const [a, setA] = useState<LatLon | null>(null);
  const [b, setB] = useState<LatLon | null>(null);

  useMapEvents({
    click: (e) => {
      if (!active) return;
      const ll = { lat: e.latlng.lat, lon: e.latlng.lng };
      if (!a || (a && b)) {
        setA(ll);
        setB(null);
      } else {
        setB(ll);
      }
    },
  });

  const dist = a && b ? haversineMeters(a, b) : null;
  const brg = a && b ? bearingDeg(a, b) : null;
  const line = a && b ? ([[a.lat, a.lon], [b.lat, b.lon]] as [number, number][]) : null;

  return (
    <>
      <div className="leaflet-top leaflet-right">
        <div className="leaflet-control m-2">
          <button
            type="button"
            onClick={() => {
              setActive((v) => !v);
              setA(null);
              setB(null);
            }}
            className={clsx(
              'px-3 lg:px-2 py-1 min-h-11 lg:min-h-0 rounded text-xs font-semibold border touch-manipulation',
              active
                ? 'bg-command-accent text-command-bg border-command-accent'
                : 'bg-command-bg/90 text-gray-300 border-command-border'
            )}
          >
            📏 {active ? 'Rangefinder ON' : 'Rangefinder'}
          </button>
          {dist != null && brg != null && (
            <div className="mt-1 px-2 py-1 rounded bg-command-bg/90 border border-command-border text-[10px] text-gray-200 font-tactical">
              {formatDistance(dist)} · {formatBearing(brg)}
            </div>
          )}
          {active && !line && (
            <div className="mt-1 px-2 py-1 rounded bg-command-bg/90 border border-command-border text-[10px] text-gray-400">
              Click two points…
            </div>
          )}
        </div>
      </div>
      {line && <Polyline positions={line} pathOptions={{ color: '#00d4aa', dashArray: '6 6', weight: 2 }} />}
    </>
  );
}
